import PropTypes from 'prop-types';
import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import { Content } from './Content';

const InvestorProfileSections = ({
  loading,
  collection,
}) => {
  return (
    <DataContainer
      component={Content}
      loading={loading}
      componentProps={{
        collection,
      }}
    />
  );
};

InvestorProfileSections.propTypes = {
  loading: PropTypes.bool.isRequired,
  collection: PropTypes.object.isRequired,
};

InvestorProfileSections.defaultProps = {
};

export default InvestorProfileSections;
